import { render, staticRenderFns } from "./ModuleManageSetting.vue?vue&type=template&id=6dfb45bc&scoped=true"
import script from "./ModuleManageSetting.vue?vue&type=script&lang=js"
export * from "./ModuleManageSetting.vue?vue&type=script&lang=js"
import style0 from "./ModuleManageSetting.vue?vue&type=style&index=0&id=6dfb45bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb45bc",
  null
  
)

export default component.exports